module.exports = __webpack_public_path__ + "static/media/apartment20.22e3230a.jpg";